import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import { ThemeProvider } from "@emotion/react";
import { customTheme } from "./them/customeThem";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles"
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import ListItemIcon from "@mui/material/ListItemIcon";
import AdminNavbar from "./Navigation/AdminNavbar";
import Dashboard from "./Views/Admin";
import { Route, Routes, useNavigate } from "react-router-dom";
import DemoAdmin from "./Views/DemoAdmin";
import CreateProductForm from "./componets/createProduct/CreateProductFrom";
import CreateProuductDemo from "./componets/createProduct/CreateProuductDemo";
import CreateProduct from "../customer/Components/Create/CreateProduct";
import "./AdminPannel.css";
import ProductsTable from "./componets/Products/ProductsTable";
import OrdersTable from "./componets/Orders/OrdersTable";
import Customers from "./componets/customers/customers";
import UpdateProductForm from "./componets/updateProduct/UpdateProduct";
import SaleToggle from "./componets/SaleToggle/SaleToggle";
import FeaturesManagement from "./componets/FeaturesManagement/FeaturesManagement";
import ABTestingToggle from "./componets/ABTesting/ABTesting";

const drawerWidth = 240;

const menu = [
    { name: "Dashboard", path: "/admin" },
    { name: "Products", path: "/admin/products" },
    { name: "Customers", path: "/admin/customers" },
    { name: "Orders", path: "/admin/orders" },
    { name: "Total Earnings", path: "/admin" },
    { name: "Weekly Overview", path: "/admin" },
    { name: "Monthly Overview", path: "/admin" },
    { name: "Add Product", path: "/admin/product/create" },
    { name: "SaleToggle", path: "/admin/saletoggle" },
    { name: "Fetures Management", path: "/admin/FeaturesManagement" },
    { name: "Admin Feature Toggle", path: "/admin/AdminFeatureToggle" },
];

export default function AdminPannel() {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
    const [sideBarVisible, setSideBarVisible] = React.useState(false);
    const navigate = useNavigate();

    const drawer = (
        <Box
            sx={{
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
        >
            {isLargeScreen && <Toolbar />}
            <List>
                {menu.map((item, index) => (
                    <ListItem key={item.name} disablePadding onClick={() => navigate(item.path)}>
                        <ListItemButton>
                            <ListItemIcon>
                                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                            </ListItemIcon>
                            <ListItemText primary={item.name} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>

            <List sx={{ position: "absolute", bottom: 0, width: "100%" }}>
                <Divider />
                {["Account", "Request"].map((text, index) => (
                    <ListItem key={text} disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                            </ListItemIcon>
                            <ListItemText primary={text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    const handleSideBarViewInMobile = () => {
        setSideBarVisible(true);
    };

    const handleCloseSideBar = () => {
        setSideBarVisible(false);
    };

    const handleNavigate = (path) => {
        navigate(path);
    };


    const drawerVariant = isLargeScreen ? "permanent" : "temporary";

    return (
        <ThemeProvider theme={customTheme}>
            <Box sx={{ display: `${isLargeScreen ? "flex" : "block"}` }}>
                <CssBaseline />
                <AdminNavbar handleSideBarViewInMobile={handleSideBarViewInMobile} />

                <Drawer
                    variant={drawerVariant}
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        [`& .MuiDrawer-paper`]: {
                            width: drawerWidth,
                            boxSizing: "border-box",
                            ...(drawerVariant === "temporary" && {
                                top: 0,
                                [`& .MuiPaper-root.MuiDrawer-paperAnchorTop.MuiDrawer-paperTemporary`]:
                                    {
                                        position: "fixed",
                                        left: 0,
                                        right: 0,
                                        height: "100%",
                                        zIndex: (theme) => theme.zIndex.drawer + 2,
                                    },
                            }),
                        },
                    }}
                    open={isLargeScreen || sideBarVisible}
                    onClose={handleCloseSideBar}
                >
                    {drawer}
                </Drawer>
                <Box className="adminContainer" component="main" sx={{ flexGrow: 1 }}>
                    <Toolbar />
                    <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/product/create" element={<CreateProductForm />} />
                        <Route path="/product/update/:productId" element={<UpdateProductForm />} />
                        <Route path="/products" element={<ProductsTable />} />
                        <Route path="/orders" element={<OrdersTable />} />
                        <Route path="/customers" element={<Customers />} />
                        <Route path="/demo" element={<DemoAdmin />} />
                        <Route path="/SaleToggle" element={<SaleToggle />} />
                        <Route path="/FeaturesManagement" element={<FeaturesManagement />} />
                        <Route path="/AdminFeatureToggle" element={<ABTestingToggle />} />
                    </Routes>

                </Box>
            </Box>
        </ThemeProvider>
    );
}
